import React from "react";
import PropTypes from "prop-types";
import { Col } from "react-bootstrap";
import { CurrencyField, FormRow } from "MODULES/shared/components/Forms";
import translateProps from "MODULES/shared/decorators/translateProps";
import { properCase } from "LIB/formatters/text";
import {
  APPROVAL_STATUS,
  CORE_RETURN_FEE_SAVINGS,
  EXCHANGE,
  FINAL_EVALUATION_APPROVED,
  LABOR_COST,
  NOT_TO_EXCEED,
  ORIGINAL_EVALUATION,
  OUTSIDE_LABOR_COST,
  PART_COST,
  REPAIR_EVALUATION_APPROVED,
  REPAIR_EVALUATION_REJECTED,
  SHOP_ASSIST,
  SHOP_ASSIST_COST
} from "MODULES/RepairOrders/constants";
import {
  calculateSubtotal,
  coreReturnFeeSavingsVal
} from "MODULES/RepairOrders/helpers";
import { FLAT_EXCHANGE } from "MODULES/SalesOrders/constants";
import RepairAndHold from "./RepairAndHoldSection";

export function CostSection({
  disabled,
  evalNotRejected,
  finalEvalApproved,
  getField,
  hasAssistItems,
  requestedAction,
  scrapped,
  setFieldValue
}) {
  const subtotal = calculateSubtotal(getField);

  const coreReturnSavingsComparator = getField(FLAT_EXCHANGE)
    ? getField(NOT_TO_EXCEED)
    : getField(ORIGINAL_EVALUATION);

  const evalApproved = getField(APPROVAL_STATUS) === REPAIR_EVALUATION_APPROVED;
  const originalEval = getField(ORIGINAL_EVALUATION) != null;

  return (
    <React.Fragment>
      <FormRow>
        {evalNotRejected &&
          !scrapped && [
            <Col md={3} key="ro-item-part-cost">
              <CurrencyField
                name={PART_COST}
                label="Parts Cost"
                required={evalApproved || originalEval}
                disabled={finalEvalApproved || disabled}
                onChange={(ev, val) => {
                  if (getField(EXCHANGE)) {
                    setFieldValue(
                      CORE_RETURN_FEE_SAVINGS,
                      coreReturnFeeSavingsVal(
                        coreReturnSavingsComparator,
                        subtotal([LABOR_COST, OUTSIDE_LABOR_COST], val)
                      )
                    );
                  }
                }}
              />
            </Col>,
            <Col md={3} key="ro-item-labor-cost">
              <CurrencyField
                name={LABOR_COST}
                label={properCase(LABOR_COST)}
                required={evalApproved || originalEval}
                disabled={finalEvalApproved || disabled}
                onChange={(ev, val) => {
                  if (getField(EXCHANGE)) {
                    setFieldValue(
                      CORE_RETURN_FEE_SAVINGS,
                      coreReturnFeeSavingsVal(
                        coreReturnSavingsComparator,
                        subtotal([OUTSIDE_LABOR_COST, PART_COST], val)
                      )
                    );
                  }
                }}
              />
            </Col>,
            <Col md={3} key="ro-item-outside-labor-cost">
              <CurrencyField
                name={OUTSIDE_LABOR_COST}
                label={properCase(OUTSIDE_LABOR_COST)}
                disabled={finalEvalApproved || disabled}
                onChange={(ev, val) => {
                  if (getField(EXCHANGE)) {
                    setFieldValue(
                      CORE_RETURN_FEE_SAVINGS,
                      coreReturnFeeSavingsVal(
                        coreReturnSavingsComparator,
                        subtotal([LABOR_COST, PART_COST], val)
                      )
                    );
                  }
                }}
              />
            </Col>
          ]}
        {hasAssistItems &&
          evalNotRejected && (
            <Col md={3}>
              <CurrencyField
                name={SHOP_ASSIST_COST}
                value={getField(SHOP_ASSIST_COST)}
                label={properCase(SHOP_ASSIST_COST)}
                disabled
                readonly
              />
            </Col>
          )}
      </FormRow>
      <FormRow>
        {requestedAction !== SHOP_ASSIST && (
          <RepairAndHold
            disabled={disabled}
            getField={getField}
            setFieldValue={setFieldValue}
          />
        )}
      </FormRow>
    </React.Fragment>
  );
}

const withApprovalStatus = translateProps(({ getField, lineItem }) => ({
  evalNotRejected: getField(APPROVAL_STATUS) !== REPAIR_EVALUATION_REJECTED,
  hasAssistItems: lineItem.get("shop_assist_line_items", []).length > 0,
  scrapped: lineItem.get("scrap_report"),
  finalEvalApproved: getField(FINAL_EVALUATION_APPROVED)
}));

export default withApprovalStatus(CostSection);

CostSection.propTypes = {
  evalNotRejected: PropTypes.bool,
  hasAssistItems: PropTypes.bool,
  disabled: PropTypes.bool,
  finalEvalApproved: PropTypes.bool,
  getField: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func,
  requestedAction: PropTypes.string,
  scrapped: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/FormSections/CostSection.jsx